import { ComponentType, useEffect, useState } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { useTranslation } from 'next-i18next';

import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/system';

import { isWebview } from '@/utils/environment';
import { iOsProcessCancelHandler } from '@/utils/iosHandlers';

const ErrorContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100vw',
});

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  marginTop: theme.spacing(3),
}));

export const ErrorFallbackPage: ComponentType<FallbackProps> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation();
  const [isBackToQrButtonDisplayed, setIsBackToQrButtonDisplayed] = useState(false);
  useEffect(() => {
    setIsBackToQrButtonDisplayed(isWebview());
  }, []);

  return (
    <ErrorContainer>
      <Typography variant="h4">{`${t('genericError')}...`}</Typography>
      <Typography py={1} variant="subtitle1">
        {t('genericErrorDetails')}
      </Typography>
      <ActionButton
        data-testid="error-retry"
        variant="text"
        color="primary"
        onClick={resetErrorBoundary}
        startIcon={<RefreshOutlinedIcon />}>
        {t('button.retry')}
      </ActionButton>
      {isBackToQrButtonDisplayed && (
        <ActionButton
          variant="text"
          color="primary"
          onClick={iOsProcessCancelHandler}
          startIcon={<QrCodeScannerIcon />}>
          {t('button.backToQReader')}
        </ActionButton>
      )}
    </ErrorContainer>
  );
};
